<template>
  <div class="addBatch">
    <!-- 添加买家 -->
    <md-popup v-model="show" :mask-closable="false">
      <!-- <md-popup-title-bar title="新增批次" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar> -->
      <div class="pop_content">
        <div class="close_pop" @click="cancelPop">
          <md-icon name="wrong" size="md" ></md-icon>
        </div>
        <!-- 货主列表 -->
        <div class="pop_select_box">
          <div class="title">选择货主</div>
          <div class="search_box">
            <div class="list_search">
              <input type="text" v-model="ownerListQuery.name" @input="handleBatchSearch()" placeholder="搜索货主姓名" />
              <span class="icon_search">
                <md-icon name="search" size="sm" color="#888"></md-icon>
              </span>
              <span class="icon_close" v-if="ownerListQuery.name" @click="ownerListQuery.name = '';handleBatchSearch()">
                <md-icon name="close" size="sm" color="#888"></md-icon>
              </span>
            </div>
            <div class="btn br4" @click="handleAddOwner">
              添加
            </div>
          </div>
          <!-- 货主列表 -->
          <div class="list">
            <md-scroll-view style="height:100%;" ref="ownerScrollView" :scrolling-x="false" @refreshing="handleOwnerListRefresh"  @end-reached="handleOwnerListMore" :auto-reflow="true" >
              <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh>
              <div class="owner_list">
                <div class="list_item" v-for="(item,index) in ownerList" :key="index" @click="handleSelectSupplier(item)">
                  <span>{{item.name.slice(0,1)}}</span>
                  <div class="item_name mand-ellipsis" style="width:2.9rem;">{{item.name}}</div>
                </div>
                <!-- <div style="color:#999;font-size:0.18rem;text-align:center">没有找到新增一个？</div> -->
              </div>
              <md-scroll-view-more :finished-text="ownerList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="o_isFinished" > </md-scroll-view-more>
            </md-scroll-view>
            <div style="width:100%;text-align:center;font-size:0.2rem;color:#999;margin:0.1rem 0;">没有更多了~</div>
          </div>
        </div>
        <!-- 表单 -->
        <div class="pop_add_box">
          <!-- 标题 -->
          <div class="title">
            新增批次
          </div>
          <!-- 货主 -->
          <div class="owner_name input_add_batch">
            <!-- <div>货主</div>
            <div class="input_add_batch_2">
              <input placeholder="请先选择货主" type="text" v-model="subData.supplier_name" readonly>
            </div> -->
            <md-input-item title="选择货主" placeholder="请先选择货主" v-model="subData.supplier_name" readonly></md-input-item>
          </div>
          <!-- 批次号 -->
          <div class="owner_batch_no input_add_batch">
            <!-- <div>批次编号</div>
            <div class="input_add_batch_2">
              <input placeholder="批次编号" type="text" v-model="subData.batch" readonly>
            </div> -->
            <md-input-item title="批次编号" placeholder="批次编号" v-model="subData.batch" readonly></md-input-item>
          </div>
          <!-- 售卖方式 -->
          <div class="owner_type input_add_batch">
            <!-- <div>售卖方式</div>
            <md-field-item>
              <md-radio-group v-model="subData.type">
                <md-radio-box name="1">自营</md-radio-box>
                <md-radio-box name="2">代卖</md-radio-box>
              </md-radio-group>
            </md-field-item> -->
            <md-field-item title="售卖方式">
              <md-radio-group v-model="subData.type">
                <md-radio-box name="1">自营</md-radio-box>
                <md-radio-box name="2">代卖</md-radio-box>
              </md-radio-group>
            </md-field-item>
          </div>
          <!-- 车牌号 -->
          <div class="owner_batch_no input_add_batch">
            <!-- <div>车牌号</div>
            <div class="input_add_batch_2">
              <input placeholder="车牌号" type="text" v-model="subData.batch" readonly>
            </div> -->
            <md-input-item title="车牌号" placeholder="请输入车牌号" v-model="subData.cart_no"></md-input-item>
          </div>
          <!-- 保存按钮 -->
          <div class="pop_addBuyer_btns">
            <md-button type="primary" size="small" @click="submitData">保存</md-button>
          </div>
        </div>
      </div>
    </md-popup>

    <!-- 添加货主 -->
    <addOwner ref="addOwner" @finish="handleFinish"></addOwner>
  </div>
</template>

<script>
import { owner_list } from "@/api/work/owner";
import addOwner from "./../owner/addOwner";
import { isEmpty, isMobile  } from "@/utils/validate";
import { batch_create ,batch_getNum } from "@/api/work/stock";
export default {
  name: 'addBatch',
  components:{addOwner},
  data(){
    return {
      show:false,
      subData:{
        supplier_id:'',
        supplier_name:'',
        goods:JSON.stringify([]),
        surcharge:JSON.stringify([]),
        batch:'',
        type:"1",
        cart_no:''
      },
      loading:true,

      ownerList:[],

      o_isFinished:false,
      ownerListQuery:{
        page:1,
        pageSize:10,
        name:'',
        status:1,
      }
    }
  },
  created(){
    
  },
  mounted(){




  },
  methods:{
    // 显示弹窗
    showPop(){
      // this.getOwnerList()
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        supplier_id:'',
        supplier_name:'',
        goods:JSON.stringify([]),
        surcharge:JSON.stringify([]),
        batch:'',
        type:"1",
        cart_no:''
      }
      this.ownerListQuery={
        name:'',
        status:1,
      }
    },

    
    // 下拉刷新数据
    handleOwnerListRefresh() {
      this.ownerListQuery.page = 1;
      setTimeout(()=>{
        this.getOwnerList()
      },500)
    },
    // 加载更多数据
    handleOwnerListMore(){
      if (this.o_isFinished) {
        return
      }
      this.$refs.ownerScrollView.finishLoadMore()
      this.getOwnerList()
    },
    // 输入搜索
    handleBatchSearch(){
      this.ownerListQuery.page = 1;
      this.getOwnerList()
    },
    // 获取可用货主列表
    getOwnerList(){
      owner_list(this.ownerListQuery).then(res=>{
        if(res.code == 200 ){
          if(this.ownerListQuery.page == 1) this.ownerList = []
          this.ownerList = this.ownerList.concat(res.data.list)
          if(this.ownerList.length >= res.data.totalCount || res.data.list.length == 0){
              this.o_isFinished = true;
          }else{
              this.o_isFinished = false;
              this.ownerListQuery.page++;
          }
          this.$nextTick(()=>{
            if(this.ownerList.length > 0){
              this.$refs.ownerScrollView.finishRefresh()
            }
          })
        }
      })
    },

    // 点击了货主
    handleSelectSupplier(item){
      this.subData.supplier_id = item.id
      this.subData.supplier_name = item.name
      // 获取批次号
      batch_getNum({id:item.id,num:item.supplier_sn}).then(res=>{
        this.subData.batch = res.data.batchNum
      })
    },


    // 提交数据
    submitData(){ 
      if(!this.loading){
        return false
      }
      if(!this.subData.supplier_id){ this.$toast.info("请选择货主！"); return false }
      // if(!this.subData.cart_no){ this.$toast.info("请输入车牌号！"); return false }
      this.loading = false
      batch_create(this.subData).then(res=>{
        this.$toast.succeed(res.message)
        this.finishPop()
        this.loading = true
      })
    },
    // 点击了新增货主
    handleAddOwner(){
      this.$refs.addOwner.showPop()
    },
    // 
    handleFinish(){
      this.ownerListQuery.page = 1;
      this.getOwnerList()
    }
  }
}
</script>

<style lang="less" scoped>
.addBatch{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 9rem;
    height: 6.6rem;
    background-color: #fff;
    border-radius: 0.08rem;
    overflow: hidden;
    padding:0 0.2rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    .close_pop{
      width: 0.6rem;
      height: 0.68rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
    }
    .title{
      font-size: 0.28rem;
      line-height: 0.68rem;
    }
    .pop_add_box{
      width: 5rem;
      &>div{
        margin-bottom: 0.4rem;
      }
      .input_add_batch{
        // &>div:nth-child(1){
        //   // line-height: 0.6rem;
        // }
        &>.input_add_batch_2{
          line-height: 0.6rem;
          border-bottom: 0.01rem solid #eee;
        }
      }
      &>.pop_addBuyer_btns{
        margin-top: 0.6rem;
      }
    }
    .pop_select_box{
      width: 3.4rem;
      .search_box{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding-right: 0.05rem;
        .btn{
          width: 0.8rem;
          height: 0.4rem;
          text-align: center;
          color: #fff;
          background-color: #31b158;
          font-size: 0.2rem;
          // border: 0.01rem solid transparent;
          text-align: center;
          line-height: 0.4rem;
          // display: flex;
          // align-items: center;
          // justify-content: center;
        }
      }
      .list_search{
        width: 2.5rem;
        height: 0.48rem;
        // padding:  0.03rem 0;
        padding: 0;
        // border:0.01rem solid #e1e1e1;
        margin-bottom: 0.1rem;
        span{
          top: 0.1rem;
          &.icon_search{
            left: 0.1rem;
            font-size: 0.2rem;
          }
        }
      }
      .list{
        width: 100%;
        height: 5.34rem;
        overflow: auto;
        .list_item{
          height: 0.56rem;
          line-height: 0.56rem;
          border-bottom: 0.01rem solid #eee;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          span{
            width: 0.4rem;
            height: 0.4rem;
            line-height: 0.4rem;
            margin-right: 0.15rem;
            border-radius: 50%;
            text-align: center;
            padding: 0 0.05rem;
            background-color: #F98463;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.addBatch{
  .md-field-item-title{
    width: 1.2rem !important;
  }
}
</style>